export default "__VITE_ASSET__CSlQCvqj__"